import React from "react";
import "./Navbar.css";

export const Navbar = () => {
	return (
		<div className="navcontainer">
			<div className="navinner">
				<i class="fa-solid fa-chevron-left"></i>
				<span>Reviews Dashboard</span>
			</div>
		</div>
	);
};
